<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cx4T6Z/tc-custom/9780226769813.jpg?1722578806485" alt="This image is the cover for the book Vice Patrol"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vice Patrol
      </h1>
      <p class="bookDescription body article font2">
        <p>In the mid-twentieth century, gay life flourished in American cities even as the state repression of queer communities reached its peak. Liquor investigators infiltrated and shut down gay-friendly bars. Plainclothes decoys enticed men in parks and clubs. Vice officers surveilled public bathrooms through peepholes and two-way mirrors.<br/>  <br/> In <i>Vice Patrol</i>, Anna Lvovsky chronicles this painful story, tracing the tactics used to criminalize, profile, and suppress gay life from the 1930s through the 1960s, and the surprising controversies those tactics often inspired in court. Lvovsky shows that the vice squads’ campaigns stood at the center of live debates about not only the law’s treatment of queer people, but also the limits of ethical policing, the authority of experts, and the nature of sexual difference itself—debates that had often unexpected effects on the gay community’s rights and freedoms. Examining those battles, <i>Vice Patrol</i> enriches understandings of the regulation of queer life in the twentieth century and disputes about police power that continue today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Lvovsky
      </h2>
      
      <p class="authorDescription body article"><B>Anna Lvovsky</B> is assistant professor of law at Harvard Law School.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?003e9bd2